import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import image from "assets/images/companies/img-1.png";
import axios from "axios";
import toast from "react-hot-toast";

import {
  Badge,
  Col,
  Container,
  Row,
  Table,
  Modal,
  Form,
  FormGroup,
  Label,
  Button,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as moment from "moment";

import { getPatientComplaintsRequest } from "../../store/feedback/actions";

import { map } from "lodash";


class ComplaintList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientappointments: [],
      complaintmodal: false,
      detail: {},
    };
    this.ToggleComplaintModal = this.ToggleComplaintModal.bind(this);
  }
  ToggleComplaintModal(item) {
    this.setState(prevState => ({
      complaintmodal: !prevState.complaintmodal,
      detail: item,
    }));
    console.log("Toggle On");
  }

  componentDidMount() {
    const { patientappointments, onGetPatientAppointments } = this.props;
    onGetPatientAppointments(
      JSON.parse(localStorage.getItem("authUser")).refresh_token
    );
    this.setState({ patientappointments });
  }

  handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y");
    return date1;
  };

  render() {
    const { patientappointments } = this.props;
    console.log(this.state.details);
    return (
      <React.Fragment>
        <Modal
          isOpen={this.state.complaintmodal}
          toggle={this.ToggleComplaintModal}
          size="lg"
          scrollable={true} // to enable scrollable body
          centered={true} //to center the modal vertically
          backdrop={"static"} //to disable click outside the modal
        >
          <div className="modal-header align-center">
            <h5 className="modal-title mt-3 ">Complaint Details</h5>
            {/*  */}
            <button
              type="button"
              onClick={() => this.setState({ complaintmodal: false })}
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <Form>
              <Col lg="12">
                <div className="mb-3 w-50 h-75">
                  <Label for="basicpill-address-input1">Complaint id</Label>
                  <h5>{this.state.detail.id}</h5>
                </div>

                <div className="mb-3 w-50 h-75">
                  <Label for="basicpill-address-input1">Complaint Status</Label>
                  <h5>{this.state.detail.Status}</h5>
                </div>

                <div className="mb-3 w-50 h-75">
                  <Label for="basicpill-address-input1">Complaint Type</Label>
                  <div>
                  <h5>{this.state.detail.Type}</h5>
                  </div>
                </div>
                <div className="mb-5 w-50 h-75">
                  <Label for="basicpill-address-input1">
                    Complaint description
                  </Label>
                  <div>
                    <h5>{this.state.detail.Description}</h5>
                  </div>
                </div>
                <div className="mb-5 w-50 h-75">
                  <Label for="basicpill-address-input1">
                    Complaint Resonse
                  </Label>
                  <div>
                    <h5>{this.state.detail.Response}</h5>
                  </div>
                </div>

                <div
                  style={{
                    // width: "38%",
                    display: "flex",
                    // justifyContent: "space-between",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-secondary mx-3 pl-2"
                    onClick={() => this.setState({ complaintmodal: false })}
                  >
                    Close
                  </button>
                </div>
              </Col>
            </Form>
          </div>
        </Modal>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Dashboard" breadcrumbItem="All Complaints" />
            <Row>
              <Col lg="12">
                <div className="">
                  <div className="table-responsive">
                    <Table className="project-list-table table-nowrap align-middle table-borderless">
                      <thead>
                        <tr>
                          <th scope="col" style={{ width: "100px" }}>
                            Complaint ID
                          </th>
                          <th className="text-center" scope="col">
                            Type
                          </th>
                          {/* <th className="text-center" scope="col">
                            Request Date
                          </th> */}
                          {/* <th scope="col">Request Time</th> */}
                          <th className="text-center" scope="col">
                            Status
                          </th>
                          <th className="text-center" scope="col">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {map(patientappointments, (apt, index) => (
                          <tr key={index}>
                            <td className="text-center">
                              <Link to={`/#`} className="text-dark">
                                {apt.id}
                              </Link>
                            </td>
                            <td className="text-center">
                              <h5 className="text-truncate font-size-14">
                                <Link to={`/#`} className="text-dark">
                                  {apt.Type}
                                </Link>
                              </h5>
                              <p className="text-muted mb-0">{apt.Lab_Id}</p>
                            </td>

                            {/* <td className="text-center">
                              {this.handleValidDate(apt.ReqDate)}
                            </td>
                            <td>{project.ReqTime}</td> */}
                            <td className="text-center">
                              {apt.Status === "Resolved" ? (
                                <Badge
                                  bg="success"
                                  className={
                                    "font-size-12 badge-soft-success bg-soft-warning rounded-pill"
                                  }
                                >
                                  {apt.Status}
                                </Badge>
                              ) : (
                                <Badge
                                  bg="warning"
                                  className={
                                    "font-size-12 badge-soft-warning badge bg-warning rounded-pill"
                                  }
                                >
                                  {apt.Status}
                                </Badge>
                              )}
                            </td>

                            <td className="text-center">
                              <Button
                                onClick={() => {
                                  this.ToggleComplaintModal(apt);
                                  this.setState({ detail: apt });
                                  console.log(this.state.detail);
                                }}
                                className="btn btn-primary btn-sm btn-rounded"
                              >
                                View Details
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            </Row>

            {/* <Row>
                  <Col xs="12">
                    <div className="text-center my-3">
                      <Link to="#" className="text-success">
                        <i className="bx bx-loader bx-spin font-size-18 align-middle me-2" />
                        Load more
                      </Link>
                    </div>
                  </Col>
                </Row> */}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ComplaintList.propTypes = {
  className: PropTypes.any,
  onGetPatientAppointments: PropTypes.func,
  patientappointments: PropTypes.array,
};

const mapStateToProps = state => ({
  loading: state.PatientComplaintReducer.isLoading,
  error: state.PatientComplaintReducer.error,
  patientappointments: state.PatientComplaintReducer.patientcomplaints,
});

const mapDispatchToProps = dispatch => ({
  onGetPatientAppointments: token => {
    console.log("token dispatched", token);
    dispatch(getPatientComplaintsRequest(token));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ComplaintList);
